export { default } from './BorrowingTitle';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingTitle/index.js